<template>
    <div>
        <div :id="btnId"
            :class="{'disable': isBtnDisable}">
            <div
                v-html="btnMsg"
                @click="clickButton"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Button',
    props: {
        btnId: String,
        btnMsg: String,
        isBtnDisable: Boolean
    },
    methods: {
        clickButton: function () {
            if (this.isBtnDisable) return;

            this.$emit('clickButton');
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/input/baseButton';
.btn-wrapper {
    @include btn-wrapper;
}
</style>
